module.exports = __webpack_public_path__ + "static/media/S2N7-1.a227d585.svg";